export type UIStyle = 'classic' | 'ios';

export const normalizeUIStyle = (value?: string | null): UIStyle =>
  value === 'classic' ? 'classic' : 'ios';

export const applyUIStyle = (value?: string | null): UIStyle => {
  const uiStyle = normalizeUIStyle(value);

  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-ui-style', uiStyle);
  }

  return uiStyle;
};
